import { request as requestBase } from 'graphql-request';
import { useAuthStateStore, useQueryContextStore } from '@annunciate/core';
import { NetworkRequestError } from '../utils';
export const request = async ({ query, variables = {}, endpoint = useQueryContextStore.getState().endpoint, }) => {
    const token = useAuthStateStore.getState().token;
    return requestBase(`${endpoint}/graphql`, query, variables, {
        authorization: token ? `Bearer ${token}` : '',
    }).catch((err) => {
        if (err?.message === 'Network request failed') {
            throw new NetworkRequestError();
        }
        else {
            throw err;
        }
    });
};
//# sourceMappingURL=request.js.map